import { ListItemIcon, MenuItem, Typography } from "@mui/material";
import React from "react";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import { useTheme } from "@emotion/react";
import { toast } from "react-hot-toast";

export default function PasteImageMenuItem({ callback = () => {}, handleClose }) {
  const theme = useTheme();

  const handlePaste = async () => {
    try {
      const clipboardItems = await navigator.clipboard.read();
      for (const item of clipboardItems) {
        for (const type of item.types) {
          if (type.startsWith("image/")) {
            const blob = await item.getType(type);
            callback(blob);
            return;
          }
        }
      }
      toast.error("No image found in clipboard.");
    } catch (err) {
      toast.error("Clipboard read failed.");
    } finally {
      handleClose();
    }
  };

  return (
    <MenuItem
      onClick={handlePaste}
      sx={{
        minWidth: "180px",
        color: theme.palette.text.main,
      }}
    >
      <ListItemIcon
        sx={{
          color: theme.palette.text.main,
        }}
      >
        <ContentPasteIcon fontSize="small" />
      </ListItemIcon>
      <Typography>Paste</Typography>
    </MenuItem>
  );
}
